import _defineProperty from "/home/kamaleddin/apps/coolpic-site/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/home/kamaleddin/apps/coolpic-site/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["alt", "bordered", "children", "img", "color", "rounded", "size", "stacked", "status", "statusPosition", "placeholderInitials", "className"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { useTheme } from '../Flowbite/ThemeContext';
import AvatarGroup from './AvatarGroup';
import AvatarGroupCounter from './AvatarGroupCounter';
var AvatarComponent = function AvatarComponent(_ref) {
  var _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? '' : _ref$alt,
    _ref$bordered = _ref.bordered,
    bordered = _ref$bordered === void 0 ? false : _ref$bordered,
    children = _ref.children,
    img = _ref.img,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'light' : _ref$color,
    _ref$rounded = _ref.rounded,
    rounded = _ref$rounded === void 0 ? false : _ref$rounded,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    _ref$stacked = _ref.stacked,
    stacked = _ref$stacked === void 0 ? false : _ref$stacked,
    status = _ref.status,
    _ref$statusPosition = _ref.statusPosition,
    statusPosition = _ref$statusPosition === void 0 ? 'top-left' : _ref$statusPosition,
    _ref$placeholderIniti = _ref.placeholderInitials,
    placeholderInitials = _ref$placeholderIniti === void 0 ? '' : _ref$placeholderIniti,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var theme = useTheme().theme.avatar;
  var imgClassName = classNames(bordered && theme.bordered, bordered && theme.color[color], rounded && theme.rounded, stacked && theme.stacked, theme.img.on, theme.size[size]);
  return _jsxs("div", _objectSpread(_objectSpread({
    className: classNames(theme.base, className),
    "data-testid": "flowbite-avatar"
  }, props), {}, {
    children: [_jsxs("div", {
      className: "relative",
      children: [img ? _jsx("img", {
        alt: alt,
        className: classNames(imgClassName, theme.img.on),
        "data-testid": "flowbite-avatar-img",
        src: img
      }) : placeholderInitials ? _jsx("div", {
        className: classNames(theme.img.off, theme.initials.base, rounded && theme.rounded, stacked && theme.stacked, bordered && theme.bordered),
        children: _jsx("span", {
          className: classNames(theme.initials.text),
          "data-testid": "flowbite-avatar-initials-placeholder",
          children: placeholderInitials
        })
      }) : _jsx("div", {
        className: classNames(imgClassName, theme.img.off),
        "data-testid": "flowbite-avatar-img",
        children: _jsx("svg", {
          className: theme.img.placeholder,
          fill: "currentColor",
          viewBox: "0 0 20 20",
          xmlns: "http://www.w3.org/2000/svg",
          children: _jsx("path", {
            fillRule: "evenodd",
            d: "M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z",
            clipRule: "evenodd"
          })
        })
      }), status && _jsx("span", {
        className: classNames(theme.status.base, theme.status[status], theme.statusPosition[statusPosition])
      })]
    }), children && _jsx("div", {
      children: children
    })]
  }));
};
AvatarComponent.displayName = 'Avatar';
export var Avatar = Object.assign(AvatarComponent, {
  Group: AvatarGroup,
  Counter: AvatarGroupCounter
});